import { useMemo } from 'react';
import cx from 'classnames';
import Link from './Link.js';
import styles from '../Footer.module.scss.js';
import { LinkBehaviour } from '../../../types/shared.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const SitemapListItem = ({
  link
}) => {
  const {
    behaviour,
    text = "",
    url
  } = link ?? {};
  const nextLink = behaviour === LinkBehaviour.Standard;
  const target = behaviour === LinkBehaviour.Standard ? "_self" : "_blank";
  const rel = behaviour === LinkBehaviour.Standard ? "_self" : "noopener noreferrer";
  return /* @__PURE__ */ jsx("li", {
    children: url ? /* @__PURE__ */ jsx(Link, {
      href: url,
      nextLink,
      target,
      testId: `footer-${text}`,
      rel,
      children: text
    }) : /* @__PURE__ */ jsx("span", {
      "data-test-id": `footer-${text}`,
      children: text
    })
  });
};
const SitemapList = ({
  text,
  links,
  isHeadingUppercase
}) => {
  const title = useMemo(() => isHeadingUppercase ? text.toLocaleUpperCase() : text, [isHeadingUppercase, text]);
  return /* @__PURE__ */ jsxs("ul", {
    className: styles.list,
    children: [/* @__PURE__ */ jsx("li", {
      children: /* @__PURE__ */ jsx("h3", {
        "data-test-id": `footer-header-${text}`,
        className: styles.listHeading,
        children: title
      })
    }), links?.map((link) => /* @__PURE__ */ jsx(SitemapListItem, {
      link
    }, link?.text))]
  });
};
const Sitemap = ({
  footerSitemapLinks,
  footerSitemapClass,
  isHeadingUppercase = true
}) => {
  const footerSitemapClasses = cx(styles.footerSitemap, footerSitemapClass);
  return /* @__PURE__ */ jsx("div", {
    className: footerSitemapClasses,
    "data-test-id": "footer-sitemap",
    children: footerSitemapLinks?.map((link) => {
      const {
        text = "",
        children
      } = link ?? {};
      return /* @__PURE__ */ jsx(SitemapList, {
        isHeadingUppercase,
        text,
        links: children
      }, text);
    })
  });
};

export { Sitemap, SitemapList, SitemapListItem };
//# sourceMappingURL=Sitemap.js.map
